import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/shared/pageHeader/PageHeader";
import CountDownTimer from "../../components/shared/countDown/CountDownTimer";
import { isFairStarted } from "../../utils/utils";
import { ROUTES } from "../../routing/routes";
import { useHistory } from "react-router-dom";
import _environment from "../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
const ComingSoonView = (props: any) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[ComingSoonView] init");

    // If fair has started, go to home
    if (isFairStarted()) {
      console.log("ao");
      history.push(ROUTES.HOME);
    }
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[ComingSoonView] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="page-content">
        <div className={"container"}>
          <div className="box text-center">
            <PageHeader title={t("pages.comingSoon.title")}/>

            <h3>Fair will start in</h3>
            <CountDownTimer date={_environment.fairStartdate.toDate()}/>
          </div>
        </div>
      </div>
    </>
  );
};
export default ComingSoonView;
